import src from "IMAGE";
export default { src, width: 730, height: 295, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAPUlEQVR42j2KyQkAMQwD8/dtg7tS/+0sCmQfgyRGp7sxM9hdsIsIIgKZeTmU70RhZqiqC/d5giemqsLdfz5H7wvIHJTSZwAAAABJRU5ErkJggg=="};
